import { render } from "./JsonViewItem.vue?vue&type=template&id=312062a4&scoped=true"
import script from "./JsonViewItem.vue?vue&type=script&lang=js"
export * from "./JsonViewItem.vue?vue&type=script&lang=js"

import "./JsonViewItem.vue?vue&type=style&index=0&id=312062a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312062a4"]])

export default __exports__